import React from "react";
import "../styles/secretaria.css";
import KpiGrid from "../components/KpiGrid";
import OperativoTab from "../components/OperativoTab";
import AcademicTab from "../components/AcademicTab";
import { useSecretariaDashboardData } from "../hooks/useSecretariaDashboardData";

export default function SecretariaDashboard() {
  const { kpis, operativo, academico, lastUpdate, loading, fetchDashboard } = useSecretariaDashboardData();

  const operativoData = operativo || { kpis: [], funnel: [], funnelMonthly: [] };
  const academicoData = academico || { kpis: [], ocupacion: [], proximas: [] };
  const formattedLastUpdate = lastUpdate
    ? `Actualizado: ${new Date(lastUpdate).toLocaleString("es-EC")}`
    : "Sin datos";

  return (
    <div className="dashboard-page management-page management-theme-teal secretaria container-fluid py-4">
      <div className="management-card management-header secretaria-header mb-4">
        <div>
          <p className="management-eyebrow mb-1">Secretaria</p>
          <h3 className="management-title mb-1">Tablero de operaciones</h3>
          <p className="text-muted mb-2">Seguimiento rapido de interesados y aperturas.</p>
        </div>
        <div className="secretaria-header-actions">
          <button
            className="btn secretaria-refresh-btn"
            type="button"
            onClick={fetchDashboard}
            disabled={loading}
          >
            <i className="bi bi-arrow-repeat me-2" />
            {loading ? "Actualizando..." : "Actualizar"}
          </button>
          <small className="text-muted">{formattedLastUpdate}</small>
        </div>
      </div>

      <KpiGrid items={kpis} />

      <div className="mt-3">
        <OperativoTab operativo={operativoData} showKpis={false} />
      </div>

      <div className="mt-4">
        <AcademicTab academico={academicoData} />
      </div>
    </div>
  );
}
